import { render, staticRenderFns } from "./RequestPayment.vue?vue&type=template&id=ed1a3858&scoped=true"
import script from "./RequestPayment.vue?vue&type=script&lang=js"
export * from "./RequestPayment.vue?vue&type=script&lang=js"
import style0 from "./RequestPayment.vue?vue&type=style&index=0&id=ed1a3858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1a3858",
  null
  
)

export default component.exports